import { formItemProps as elFormItemProps } from 'element-plus'
import { visibleProps, disabledProps } from '@el-plus/utils/props'
import { CSSProperties } from 'vue'
import type {
  VNode,
  PropType,
  ExtractPropTypes,
  ExtractPublicPropTypes,
} from 'vue'
const expandFormItemProps = {
  type: {
    type: String,
    default: 'EpInput',
  },
  col: Number,
  render: Function as PropType<(...args: any[]) => VNode>,
  labelRender: Function as PropType<
    ({ label }: { label: string | undefined }) => VNode
  >,
  props: Object,
  ...visibleProps,
  ...disabledProps,
  class: String,
  style: {
    type: [String, Object] as PropType<string | CSSProperties>,
  },
  isShowLabel: {
    type: Boolean,
    default: true,
  },
  hideRequiredAsterisk: Boolean,
  tableProp: String, // 用于table里的表单需要绑定的prop
}
export const formItemProps = {
  ...elFormItemProps,
  ...expandFormItemProps,
  prop: String,
} as const
export type FormItemProps = ExtractPublicPropTypes<typeof formItemProps> & {
  [key: `on${string}`]: ((...args: any[]) => any) | undefined
}
export const expandFormItemPropsKeys = Object.keys(expandFormItemProps)
